/**
 * @flow
 * @relayHash ab7ce8f1f6800edcb6a1283f5458ba99
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type setNameOfUserInput = {
  userId?: ?string,
  name?: ?string,
  clientMutationId: string,
};
export type SetNameOfUserMutationVariables = {|
  input: setNameOfUserInput
|};
export type SetNameOfUserMutationResponse = {|
  +setNameOfUser: ?{|
    +user: ?{|
      +id: string,
      +pid: ?string,
      +name: ?string,
      +picture: ?string,
      +email: ?string,
      +lastActive: ?string,
      +createdAt: ?string,
      +uniqueId: ?string,
      +status: ?string,
    |},
    +clientMutationId: string,
  |}
|};
*/


/*
mutation SetNameOfUserMutation(
  $input: setNameOfUserInput!
) {
  setNameOfUser(input: $input) {
    user {
      id
      pid
      name
      picture
      email
      lastActive
      createdAt
      uniqueId
      status
    }
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "setNameOfUserInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "setNameOfUser",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "setNameOfUserInput!"
      }
    ],
    "concreteType": "setNameOfUserPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "user",
        "storageKey": null,
        "args": null,
        "concreteType": "User",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pid",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "picture",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "email",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastActive",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "createdAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "uniqueId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "SetNameOfUserMutation",
  "id": null,
  "text": "mutation SetNameOfUserMutation(\n  $input: setNameOfUserInput!\n) {\n  setNameOfUser(input: $input) {\n    user {\n      id\n      pid\n      name\n      picture\n      email\n      lastActive\n      createdAt\n      uniqueId\n      status\n    }\n    clientMutationId\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "SetNameOfUserMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "SetNameOfUserMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f38741576c59f389cc947498e9182c9b';
module.exports = node;
